module.exports = __webpack_public_path__ + "static/media/557.6fc0d12f.png";